// Dynamic code frames (design/2026-10-21-sky-sources-influencer-dynamic-frames.md
// D11–D13): where a dynamic frame shows in the Code Frames tab, and how its
// suggestions are reviewed. It opens the review page and shows the controls;
// it never accepts, merges, renames or rejects anything.

import type { Walkthrough } from './types'

export const dynamicCodeFrames: Walkthrough = {
  slug: 'dynamic-code-frames',
  title: 'Dynamic code frames',
  summary:
    'Shows how a dynamic code frame collects the model’s suggestions for new codes, and how a Manager reviews them: accept one as a new code, merge it into an existing code, rename it or reject it. Nothing is changed.',
  added: '2026-10-21',
  skipE2E: 'needs a dynamic code frame with pending suggestions on the job; the fixture job has none',
  steps: [
    {
      route: 'autocoder',
      feature: 'autocoder/autocoder-page',
      click: 'Code Frames',
      say: 'This is AutoCoder. I open the Code Frames tab, where the job’s reusable code frames are listed.',
    },
    {
      route: 'autocoder',
      feature: 'autocoder/dynamic-code-frames',
      control: 'Review suggestions',
      say: 'A dynamic code frame carries a Dynamic chip with the number of suggestions waiting. While comments are coded, the model suggests codes the frame does not have; the frame keeps them, joins ones worded alike, and changes only when a Manager accepts one. Dynamic is switched on in the code frame editor.',
    },
    {
      route: 'autocoder',
      feature: 'autocoder/dynamic-code-frames',
      click: 'Review suggestions',
      say: 'Opening the frame’s suggestions.',
    },
    {
      route: 'framework-suggestions',
      feature: 'autocoder/code-frame-suggestions',
      say: 'Each suggestion shows how often the model made it, up to five example comments, and when it was last seen. The most frequent come first.',
    },
    {
      route: 'framework-suggestions',
      feature: 'autocoder/code-frame-suggestions',
      control: 'Accept',
      say: 'Accept adds the suggestion as a new code at the end of the frame, as a new version, and to every pipeline that uses the frame. You choose From now on, or Re-code since a date, which shows the comments and credits it would take before you confirm. A walkthrough never clicks it.',
    },
    {
      route: 'framework-suggestions',
      feature: 'autocoder/code-frame-suggestions',
      control: 'Merge into…',
      say: 'Merge into… records that a suggestion means a code the frame already has, without changing the frame. Rename edits its label, and Reject sets it aside.',
    },
    {
      route: 'framework-suggestions',
      feature: 'autocoder/dynamic-code-frames',
      control: 'Group look-alikes now',
      say: 'Suggestions worded alike are joined as they arrive. Once a day the model also groups ones that mean the same thing in different words; Group look-alikes now does that at once.',
    },
    {
      route: 'framework-suggestions',
      feature: 'autocoder/code-frame-suggestions',
      control: 'Decided',
      say: 'Decided lists what was accepted, merged or rejected, and History, below, lists each version of the frame and the codes it added.',
    },
  ],
}
